interface StaleIndicatorProps {
  dataUpdatedAt: number;
}

export function StaleIndicator({ dataUpdatedAt }: StaleIndicatorProps) {
  const isOffline = typeof navigator !== 'undefined' && !navigator.onLine;
  const ageMs = Date.now() - dataUpdatedAt;
  const isStale = ageMs > 120_000;

  if (!isOffline && !isStale) return null;

  const minutesAgo = Math.floor(ageMs / 60_000);

  return (
    <div className="bg-amber-700 px-4 py-2 text-center text-sm text-white">
      {isOffline
        ? `Offline — last updated ${minutesAgo} minute${minutesAgo !== 1 ? 's' : ''} ago`
        : `Last updated ${minutesAgo} minute${minutesAgo !== 1 ? 's' : ''} ago`}
    </div>
  );
}
